import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
  Text,
} from 'web-styled';

export const LeftBar = styled(Flex).attrs({
  width: '35%',
  padding: '30px',
  column: true,
})`
  min-height: 600px;
  background-color: #666666;

  .client-notes-wrapper {
    display: flex;
    height: 380px;
    width: 100%;

    .note-content {
      height: 300px;
    }
  }
`;

export const ResetTutorial = styled(Text).attrs({
  size: '18px',
  color: '#fff',
  weight: 500,
})`
  cursor: pointer;
`;

export const BirthPicker = styled(Flex).attrs({
  width: '100%',
  column: true,
})`
  & > div {
    width: 100%;
  }
`;

export const TimezonePicker = styled(Flex).attrs({
  width: '100%',
  column: true,
})`
  & > div {
    width: 45%;
  }
`;

export const Back = styled(Button)`
  color: #fff !important;
  font-size: 18px;
  font-weight: 500;
`;
